import * as React from 'react'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import IconButton from '@mui/material/IconButton'
import Skeleton from '@mui/material/Skeleton'
import { Box, CardActions, CardContent } from '@mui/material'

const PostLoading = ({ loading }) => loading
  ? (
    <>
      <LoadingCard/>
      <LoadingImageCard/>
       <LoadingCard/>
       <LoadingCard/>
    </>
    )
  : <></>

const LoadingCard = () => (
  <>
    <Card
      elevation={0}
      sx={{
        width: 756,
        borderRadius: '16px',
        mt: -1
      }}
    >
      <CardHeader
        avatar={<Skeleton animation="wave" variant="circular" width={24} height={24} />}
        title={
          <Skeleton
            animation="wave"
            height={10}
            width="25%"
          />
        }
      />
      <CardContent sx={{ mt: -3.5 }}>
        <Skeleton animation="wave" height={35} width="50%" />
        <Skeleton animation="wave" height={25} width="95%" />
        <Skeleton animation="wave" height={25} width="40%" />
      </CardContent>
      <CardActions disableSpacing sx={{ mt: -3 }}>
        <IconButton aria-label="comment">
          <Skeleton animation="wave" variant="circular" width={25} height={25} />
        </IconButton>
        <IconButton aria-label="like">
          <Skeleton animation="wave" variant="circular" width={25} height={25} />
        </IconButton>
        <IconButton aria-label="share">
          <Skeleton animation="wave" variant="circular" width={25} height={25} />
        </IconButton>
      </CardActions>
    </Card>
    <Skeleton height={1} width="100%" sx={{ mt: -1 }} />
  </>
)

const LoadingImageCard = () => (
  <>
    <Card
      elevation={0}
      sx={{
        width: 756,
        borderRadius: '16px',
        mt: -1
      }}
    >
      <CardHeader
        avatar={<Skeleton animation="wave" variant="circular" width={24} height={24} />}
        title={
          <Skeleton
            animation="wave"
            height={10}
            width="25%"
          />
        }
      />
      <CardContent sx={{ mt: -3.5 }}>
        <Skeleton animation="wave" height={35} width="30%" />
      </CardContent>
      <Box sx={{ justifyContent: 'center', pl: 2 }}>
        <Skeleton sx={{ display: 'flex', height: 300 }} width="100%" animation="wave" variant="rounded" />
      </Box>
      <CardActions disableSpacing sx={{ mt: -0.5 }}>
        <IconButton aria-label="comment">
          <Skeleton animation="wave" variant="circular" width={25} height={25} />
        </IconButton>
        <IconButton aria-label="like">
          <Skeleton animation="wave" variant="circular" width={25} height={25} />
        </IconButton>
        <IconButton aria-label="share">
          <Skeleton animation="wave" variant="circular" width={25} height={25} />
        </IconButton>
      </CardActions>
    </Card>
    <Skeleton height={1} width="100%" sx={{ mt: -1 }} />
  </>
)

export default PostLoading
